<template>
  <div class="send-salary">
    <div class="send-salary-container">
      <div class="search">
        <div class="search-title">
          <div>实发总金额：{{totalAmount}}</div>
          <div>未查看：{{notCheckNum}}</div>
          <div>未确认：{{notConfirmNum}}</div>
        </div>
        <div class="search-content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="demo-ruleForm"
            label-width="100px"
          >
            <div class="row">
              <el-form-item label="发送状态：" prop="sendStatus">
                <el-select
                  v-model="ruleForm.sendStatus"
                  placeholder="请选择"
                  class="gray white"
                  clearable
                >
                  <el-option
                    v-for="item in sendStatusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="查看状态：" prop="checkStatus">
                <el-select
                  v-model="ruleForm.checkStatus"
                  placeholder="请选择"
                  class="gray white"
                  clearable
                >
                  <el-option
                    v-for="item in checkStatusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="确认状态：" prop="confirmStatus">
                <el-select
                  v-model="ruleForm.confirmStatus"
                  placeholder="请选择"
                  class="gray white"
                  clearable
                >
                  <el-option
                    v-for="item in confirmStatusList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="btn">
                <el-button class="btn-gray" @click="resetForm('ruleForm')">重置</el-button>
                <el-button class="btn-blue" type="primary" @click="search">搜索</el-button>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="姓名：" prop="name">
                <el-input class="gray white" placeholder="请输入" v-model="ruleForm.name" clearable></el-input>
              </el-form-item>
              <el-form-item label="职级：" prop="rank">
                <el-select
                  v-model="ruleForm.rank"
                  clearable
                  class="gray white"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in rankList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="table-container">
        <div class="table-title">
          <span>{{title}}</span>
          <el-button
            type="text"
            class="btn-blue"
            @click="sendAllSalary"
            >全部发送</el-button>
        </div>
        <div class="table" v-if="tableData.length > 0">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <div class="name-info">
                  <img class="img" :src="scope.row.img">
                  <div class="name-title">
                    <p class="name">{{scope.row.name}}</p>
                    <p>{{scope.row.rankZh}}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="部门" prop="thirdDeptName"></el-table-column>
            <el-table-column label="实发工资" prop="salary"></el-table-column>
            <el-table-column label="发送状态" prop="sendStatusVal">
              <template slot-scope="scope">
                <div class="status-info">
                  <div :class="scope.row.sendStatus == 1?'green':'red'"></div>
                  <div>{{scope.row.sendStatusVal}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="查看状态" prop="checkStatusVal">
              <template slot-scope="scope">
                <div class="status-info">
                  <div :class="scope.row.checkStatus == 1?'green':'red'"></div>
                  <div>{{scope.row.checkStatusVal}}</div>
                  <el-tooltip
                    v-if="scope.row.checkStatus == 1"
                    class="tooltip"
                    effect="dark"
                    placement="top"
                  >
                    <div slot="content">
                      <p>查看时间：{{scope.row.checkTime}}</p>
                    </div>
                    <img class="tooltip" src="../../../../assets/tooltip.png" />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="确认状态" prop="confirmStatusVal">
              <template slot-scope="scope">
                <div class="status-info">
                  <div :class="scope.row.confirmStatus == 1?'green':'red'"></div>
                  <div>{{scope.row.confirmStatusVal}}</div>
                  <el-tooltip
                    v-if="scope.row.confirmStatus == 1"
                    class="tooltip"
                    effect="dark"
                    placement="top"
                  >
                    <div slot="content">
                      <p>确认时间：{{scope.row.confirmTime}}</p>
                    </div>
                    <img class="tooltip" src="../../../../assets/tooltip.png" />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text" class="btn-text" @click="lookPaySlipDetails(scope.row.id)">查看</el-button>
                <el-button
                  v-if="scope.row.sendStatus == 0 && scope.row.withdrawnFlag == 1"
                  type="text"
                  class="btn-text"
                  @click="sendSalary(scope.row)"
                >重新发送</el-button>
                <el-button
                  v-if="scope.row.sendStatus == 0 && scope.row.withdrawnFlag == 0"
                  type="text"
                  class="btn-text"
                  @click="sendSalary(scope.row)"
                >发送</el-button>
                <el-button
                  v-if="scope.row.sendStatus == 1"
                  type="text"
                  class="btn-text-red"
                  @click="withdraw(scope.row.id)"
                >撤回</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :size="400"
      :modal="false"
      :with-header="false"
    >
      <div class="drawer-title">
        <div class="user-info">
          <img class="user-avator" :src="detailsObj.img">
          <div>
            <p class="user-name">{{detailsObj.name}}</p>
            <p>{{detailsObj.rankZh}}</p>
            <div class="net-salary">
              <span class="net-salary-title">实发工资</span>
              <span>{{detailsObj.salary}}</span>
            </div>
          </div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div
        class="drawer-content"
        v-for="(item, index) in detailsObj.categoryList"
        :key="index"
      >
        <div class="category-title">{{item.name}}</div>
        <div class="category-content">
          <div
            v-for="(v, idx) in item.itemList"
            :key="idx"
            class="category-details"
          >
            <span>{{v.key}}：</span>
            <span>{{v.value}}</span>
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 全部发送和单条发送 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <div class="send-all-nothing">
          <img src="../../../../assets/send-all-nothing.png">
        </div>
        <p class="send-title">工资条将通过浙政钉消息通知发给用户</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirmFnc">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Salary from "@/models/salary.js";
import Staff from "@/models/staff.js";
import { handleAmount, formatTimeToDate } from "@/common/js/utils.js";
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
export default {

  components: {
    PaginationTpl,
  },

  data() {
    return {
      /* 工资表id */
      salaryFormId: '',
      totalAmount: '',
      notCheckNum: '',
      notConfirmNum: '',
      title: '',
      ruleForm: {
        sendStatus: '',
        checkStatus: '',
        confirmStatus: '',
        name: '',
        rank: '',
      },
      sendStatusList: [
        {id: 0, name: '未发送'},
        {id: 1, name: '已发送'}
      ],
      checkStatusList: [
        {id: 0, name: '未查看'},
        {id: 1, name: '已查看'}
      ],
      confirmStatusList: [
        {id: 0, name: '未确认'},
        {id: 1, name: '已确认'}
      ],
      sendStatusObj: {
        0: '未发送',
        1: '已发送'
      },
      checkStatusObj: {
        0: '未查看',
        1: '已查看'
      },
      confirmStatusObj: {
        0: '未确认',
        1: '已确认'
      },
      rankList: [],      
      totalNum: 0,
      currentPage: 1,
      tableData: [],
      /* 工资条id */
      paySlipId: '',
      dialogTitle: '全部发送',
      dialogVisible: false,
      drawer: false,
      detailsObj: {
        img: '',
        name: '',
        rankZh: '',
        salary: '',
        categoryResList: []
      }
    }
  },

  created() {
    config()
    this.salaryFormId = this.$route.query.salaryFormId
    this.initSalaryFormDetails()
    this.initRankList()
    this.initPayslipList()
  },
  mounted() {
    document.getElementById("main").style.background = '#f5f6f7';
  },
  destroyed() {
    document.getElementById("main").style.background = '#fff';
  },

  methods: {
    initSalaryFormDetails() {
      let id = this.salaryFormId
      Salary.getSalaryFormDetails(id).then(res => {
        if (res.success) {
          this.totalAmount = handleAmount(res.result.totalAmount,2)
          this.notCheckNum = res.result.notCheckNum
          this.notConfirmNum = res.result.notConfirmNum
          this.title = res.result.title
        } else {
          this.$message.error(res.message);
        }
      })
    },
    
    /* 获取职级 */
    initRankList() {
      Staff.getRankList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.code = i.code
            arr.push(obj)
          })
          this.rankList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取工资条列表 */
    initPayslipList() {
      let data = {
        payrollId: this.salaryFormId,
        name: this.ruleForm.name,
        rank: this.ruleForm.rank,
        sendStatus: this.ruleForm.sendStatus,
        checkStatus: this.ruleForm.checkStatus,
        confirmStatus: this.ruleForm.confirmStatus,
        pageNo: this.currentPage,
      }
      Salary.getPaySlipList(data).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            obj.thirdDeptName = i.thirdDeptName
            obj.rankZh = i.rankZh
            obj.img = i.img
            obj.withdrawnFlag = i.withdrawnFlag
            obj.checkTime = formatTimeToDate(i.checkTime)
            obj.confirmTime = formatTimeToDate(i.confirmTime)
            obj.salary = handleAmount(i.salary,2)
            obj.sendStatus = i.sendStatus
            obj.sendStatusVal = this.sendStatusObj[i.sendStatus]
            obj.checkStatus = i.checkStatus
            obj.checkStatusVal = this.checkStatusObj[i.checkStatus]
            obj.confirmStatus = i.confirmStatus
            obj.confirmStatusVal = this.confirmStatusObj[i.confirmStatus]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /* 获取工资条详情 */
    initPayslipDetails(id) {
      Salary.getPaySlipDetials(id).then(res => {
        if (res.success) {
          let { img, name, rankZh, salary, categoryList} = res.result
          this.detailsObj.img = img
          this.detailsObj.name = name
          this.detailsObj.rankZh = rankZh
          this.detailsObj.salary = handleAmount(salary,2)
          let arr = []
          categoryList.map(i => {
            let obj = {}
            obj.name = i.name
            obj.itemList = []
            i.itemList.map(v => {
              let obj2 = {}
              obj2.key = v.key
              obj2.value = handleAmount(v.value,2)
              obj.itemList.push(obj2)
            })
            arr.push(obj)
          })
          this.detailsObj.categoryList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 搜索 */
    search() {
      this.currentPage = 1;
      this.initPayslipList();
    },

    /* 重置 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initPayslipList();
    },

    lookPaySlipDetails(id) {
      this.initPayslipDetails(id)
      this.drawer = true
    },

    /* 全部发送 */
    sendAllSalary() {
      this.dialogTitle = '全部发送'
      this.dialogVisible = true
    },

    /* 发送单个工资条 */
    sendSalary(row) {
      this.dialogTitle = `${row.name}的工资条`
      this.paySlipId = row.id
      this.dialogVisible = true
    },

    handleClose() {
      this.dialogVisible = false
    },

    /* 撤回 */
    withdraw(id) {
      this.$confirm("系统将撤回该员工当月工资条，是否继续？", "撤回工资条", {
        confirmButtonText: "撤回",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        Salary.postWithdraw(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '工资条撤回成功'
            });
            this.initPayslipList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    /* 发送单个工资条 */
    sendPaySlip() {
      let data = {
        idList: [this.paySlipId]
      }
      Salary.postSendPaySlip(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '工资条发送成功'
          });
          this.handleClose()
          this.initPayslipList();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 发送所有工资条 */
    sendAllPaySlip() {
      let data = {
        payrollId: this.salaryFormId
      }
      Salary.postSendAllPaySlip(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '工资条发送成功'
          });
          this.handleClose()
          this.initPayslipList();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    confirmFnc() {
      if (this.dialogTitle == '全部发送') this.sendAllPaySlip()
      if (this.dialogTitle != '全部发送') this.sendPaySlip()
    },

    /* 关闭抽屉 */
    closeDrawer() {
      this.drawer = false;
    },
  }
}
</script>

<style lang='scss'>
.send-salary {
  flex: 1;
  background: $bg-white;
  .send-salary-container {
    height: 100%;
  }
  .search {
    padding: 20px;
    background: $bg-white;
    .search-title {
      width: 100%;
      height: 96px;
      font-weight: 400;
      margin-bottom: 16px;
      padding: 0px 138px 0px 83px;
      box-sizing: border-box;
      font-size: $fs-medium-m;
      color: $color-BlackGrey;
      background: $bg-salary;
      @include flex-between;
    }
    .search-content {
      width: 100%;
      box-sizing: border-box;
      background: $bg-white;
      .el-form-item__label {
        padding: 0;
      }
      .el-form-item {
        width: 25%;
        margin-bottom: 10px
      }
      .row {
        @include flex-start;
        .btn {
          .el-form-item__content {
            margin-left: 20px!important;
            display: flex;
          }
        }
      }
    }
  }
  .table-container {
    margin-top: 20px;
    padding: 20px;
    background: $bg-white;
    box-sizing: border-box;
    .table-title {
      @include flex-between;
      margin-bottom: 20px;
      font-size: $fs-medium-s;
      font-weight: 400;
      color:$color-BlackGrey;
    }
    .table {
      .name-info {
        @include flex-start;
        .img {
          width: 40px;
          height: 40px;
          margin-right: 24px;
        }
        .name-title {
          p {
            height: 36px;
            line-height: 36px;
          }
          .name {
            font-size: $fs-medium-s;
            font-weight: bold;
            color: $color-BlackGrey;
          }
        }
      }
      .status-info {
        @include flex-start;
        .green {
          width: 6px;
          height: 6px;
          background: $bg-green;
          border-radius: 50%;
          margin-right: 5px;
        }
        .red {
          width: 6px;
          height: 6px;
          background: $bg-Crimson;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .tooltip {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-left: 5px;
      }
    }
    .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
      height: 72px;
      line-height: 72px;
    }
  }
  .el-select {
    .el-input__prefix, .el-input__suffix {
      top: -3px;
    }
  }
  
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }
  .el-dialog__body {
    @include flex-center;
    .send-all-nothing {
      width: 207px;
      height: 121px;
      margin-bottom: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .send-title {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-grey;
    }
  }

  .el-drawer__wrapper {
    top: 119px !important;
    right: 20px;
  }
  .user-info {
    @include flex-between;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    text-align: left;
    .user-avator {
      width: 40px;
      height: 40px;
      margin-right: 24px;
    }
    .user-name {
      font-size: $fs-medium-s;
      font-weight: bold;
      color: $color-BlackGrey;
      margin-bottom: 11px;
    }
    .net-salary {
      margin-top: 12px;
      .net-salary-title {
        margin-right: 22px;
      }
    }
  }
  .drawer-title {
    align-items: flex-start;
    margin-bottom: 16px;
  }
  .drawer-content {
    width: 360px;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey; 
    text-align: left;
    margin-bottom: 16px;
    .category-title {
      margin-bottom: 12px;
    }
    .category-content {
      padding: 16px 13px;
      background: $bg-ChangeDepartmentTree;
      .category-details {
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>
